import { readFileLineByLineAsync } from './readFileLineByLineAsync.js';
import { updateFileIfRequired } from './updateFileIfRequired.js';

const fs = {
    readFileLineByLineAsync,
    updateFileIfRequired
};

export { fs };
